import { useState, useEffect } from 'react';
import { Flex, Subtitle } from './TremorCompat';
import { Button, Icon } from './TremorCompat';
import { checkUserNameValid } from '../utils/utilities';
import Modal from 'rsuite/Modal';
import Input from 'rsuite/Input';
import { MdOutlineEdit as IconEdit } from 'react-icons/md';
import { COLOURS } from '../styles';

export const EditDevice = ({ open, device, handleClose }) => {
  const [name, setName] = useState(device.userName ?? '');
  const [usersDevName, setUsersDevName] = useState(device.usersDeviceName ?? '');
  const [valid, setValid] = useState(checkUserNameValid(device.userName ?? ''));
  const [model_type, setType] = useState(device.modelType ?? '');

  useEffect(() => {
    setName(device.userName ?? '');
    setUsersDevName(device.usersDeviceName ?? '');
    setValid(checkUserNameValid(device.userName ?? ''));
    setType(device.modelType ?? '');
  }, [device.uniqueDeviceId, device.userName, device.usersDeviceName, device.modelType]);

  const validate = (value) => {
    setName(value);
    setValid(checkUserNameValid(value));
  };

  const validateUsersName = (value) => {
    setUsersDevName(value);
    //setValid(checkUserNameValid(value));
  };

  const validateType = (e) => {
    setType(e.currentTarget.value);
  };

  return (
    <Modal open={open} onClose={() => handleClose(null)} backdrop="static">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Flex justifyContent="start" alignItems="center" className="space-x-1">
            <Icon icon={IconEdit} color={COLOURS.default} />
            <Subtitle color={COLOURS.default}>Edit controller</Subtitle>
          </Flex>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-3">
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>ID</span>
            <Input value={device.uniqueDeviceId ?? ''} disabled={true} size="sm" />
          </label>
          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Name</span>
            <Input value={name} placeholder="Enter a valid name" maxLength={300} size="sm" onChange={validate} />
          </label>

          <label style={{ display: 'block' }}>
            <span style={{ display: 'block', marginBottom: 4 }}>Custom User Name</span>
            <Input
              value={usersDevName}
              placeholder="Enter a valid name"
              maxLength={300}
              size="sm"
              onChange={validateUsersName}
            />
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Flex justifyContent="end" alignItems="center" className="space-x-2">
          <Button
            color={COLOURS.default}
            size="sm"
            onClick={() => handleClose(device, name, usersDevName, model_type)}
            disabled={!valid}
          >
            Confirm
          </Button>
          <Button color={COLOURS.default} size="sm" variant="secondary" onClick={() => handleClose(null)}>
            Cancel
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
